import script from "./BaseInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseInput.vue?vue&type=script&lang=ts&setup=true"

import "./BaseInput.vue?vue&type=style&index=0&id=2b3f2ba2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b3f2ba2"]])

export default __exports__